import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import classnames from 'classnames'
import Modal from 'react-modal'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setCurrentTab, showNavBar, showSideBar } from '../../../actions/commonActions'
import PageHeader from '../../common/PageHeader/PageHeader'
import CopyProgramDialog from '../CopyProgram/CopyProgramDialog'
import CoachProgramsActiveTab from './CoachProgramsActiveTab'
import CoachProgramsFutureTab from './CoachProgramsFutureTab'
import CoachProgramsDraftTab from './CoachProgramsDraftTab'
import CoachProgramsCompletedTab from './CoachProgramsCompletedTab'
import { perPage } from '../../../reducers/groupProgramsReducer'
import { getCoachPrograms } from '../../../actions/programActions'
import DefaultMultiActionsPopover from '../../common/PageHeader/DefaultMultiActionsPopover'

import styles from './CoachProgramsPage.module.scss'
import pageClasses from './ProgramsPage.module.scss'

const ProgramsPage = () => {
  const [showCopyProgramModal, setShowCopyProgramModal] = useState(false)
  const dispatch = useDispatch()

  const user = useSelector(state => state.user.current_user)
  const { active, future, draft, completed } = useSelector(state => state.groupPrograms)

  const fetchPrograms = (state, tab) => {
    dispatch(getCoachPrograms({
      filters: { ...state.filters, [tab]: 'true', search: state.search },
      page: state.page + 1,
      perPage: perPage,
      withEnrollments: 'true',
    }))
  }

  useEffect(() => {
    dispatch(setCurrentTab('Programs'))
    dispatch(showSideBar(true))
    dispatch(showNavBar(true))
  }, [dispatch])

  return (
    <div className={pageClasses.programsPage}>
      <PageHeader
        title='Group Programs'
        actionComponent={(
          <DefaultMultiActionsPopover
            title='Build a Program'
            isModalOpen={showCopyProgramModal}
            actions={[
              { label: 'Build a Program', link: true, to: '/programs/new' },
              { label: 'Copy Existing Program', onClick: () => setShowCopyProgramModal(true) },
            ]}
          />
        )}
      />

      <Tabs>
        <TabList className={styles.tabList}>
          <Tab className={classnames('react-tabs__tab', styles.tab)} selectedClassName={styles.activeTab}>
            Active {active.count !== null && `(${active.count})`}
          </Tab>
          <Tab className={classnames('react-tabs__tab', styles.tab)} selectedClassName={styles.activeTab}>
            Future {future.count !== null && `(${future.count})`}
          </Tab>
          <Tab className={classnames('react-tabs__tab', styles.tab)} selectedClassName={styles.activeTab}>
            Drafts {draft.count !== null && `(${draft.count})`}
          </Tab>
          <Tab className={classnames('react-tabs__tab', styles.tab)} selectedClassName={styles.activeTab}>
            Completed {completed.count !== null && `(${completed.count})`}
          </Tab>
        </TabList>

        <TabPanel className={styles.tabPanel}>
          <CoachProgramsActiveTab
            fetchPrograms={fetchPrograms}
          />
        </TabPanel>
        <TabPanel className={styles.tabPanel}>
          <CoachProgramsFutureTab
            fetchPrograms={fetchPrograms}
          />
        </TabPanel>
        <TabPanel className={styles.tabPanel}>
          <CoachProgramsDraftTab/>
        </TabPanel>
        <TabPanel className={styles.tabPanel}>
          <CoachProgramsCompletedTab
            fetchPrograms={fetchPrograms}
          />
        </TabPanel>
      </Tabs>

      <Modal
        isOpen={showCopyProgramModal}
        onRequestClose={() => setShowCopyProgramModal(false)}
        contentLabel='Copy Program Modal'
      >
        <CopyProgramDialog
          closeModal={() => setShowCopyProgramModal(false)}
          user={user}
        />
      </Modal>
    </div>
  )
}

export default ProgramsPage
